export const button = () => ({
    display: 'flex',
    justifyContent: 'center',
    padding: '32px 0',
});
